import './button.css';

import React from 'react';
import Spinner from "./Spinner";

interface Props {
    text: string
    variant?: 'primary' | 'secondary' | 'cancel',
    type?: 'submit' | 'button',
    disabled?: boolean,
    className?: string
    slim?: boolean,
    onClick?: () => void
}

const Button = ({text, variant='primary', type='button', disabled=false, slim=false, className, onClick}: Props) => {

    if (disabled) {
        return <button className={"hc_btn " + variant + " " + (className ?? '') + " disabled " + (slim ? 'slim' : '')} disabled>
            <Spinner />
        </button>
    }

    return <button type={type} className={"hc_btn " + variant + " " + (className ?? '') + (slim ? 'slim' : '')} onClick={onClick}>
        {text}
    </button>
}

export default Button;